import { Dispatch } from 'react';

import { isNil } from 'lodash';

import { RootState } from '../../../root/store';
import { moduleName } from '../constants';
import { currentUserIdSel } from './selectors';

export const ROUTE_UNIT_PAYMENT_LOGS = `${moduleName}/ROUTE_UNIT_PAYMENT_LOGS`;
export const goToUnitPaymentLogs = () => ({
  type: ROUTE_UNIT_PAYMENT_LOGS,
});

type GoToYouthLogs = Dispatch<{
  type: string;
  payload: { userId: number | undefined };
}>;
export const ROUTE_USER_PAYMENT_LOGS = `${moduleName}/ROUTE_USER_PAYMENT_LOGS`;

export const goToUserPaymentLogs =
  (providedUserId?: number) =>
  (dispatch: GoToYouthLogs, getState: () => RootState) => {
    let userId = providedUserId;

    if (isNil(providedUserId)) {
      const state = getState();
      userId = currentUserIdSel(state);
    }

    return dispatch({
      type: ROUTE_USER_PAYMENT_LOGS,
      payload: { userId },
    });
  };
